import type { AssetType } from '~/types/asset'

// TODO: Remove include fallback once the AssetType endpoint provides isGateway flag
export const isGatewayAssetTypeId = (assetTypeId: string, isGatewayFlag?: boolean): boolean => {
  if (isGatewayFlag !== undefined) {
    return isGatewayFlag
  }

  return assetTypeId.toLowerCase().includes('gateway')
}

export const excludeGatewayAssetTypes = (assetTypes: AssetType[]): AssetType[] => {
  return assetTypes.filter((type) => !isGatewayAssetTypeId(type.assetTypeId))
}
